import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Well, Image } from 'react-bootstrap'

const WelcomeComponent = () => (
  <Fragment>
    <Row>
      <Col xs={true}>
        <Well className="white_background welcome-to-customer-center">
          <h3>
            Welcome to the Customer Center!
          </h3>
          <p>
            { 'Think of this as "home base". ' }
            { 'You can always get here by clicking "Customer Center" on the top right of any page.' }
          </p>
          <p>
            Here, you can manage default settings for all events, leagues, and trips you create 
            (a real time-saver), as well as manage your master roster if you have one 
            (e.g., a private club with a member roster).
          </p>
          <p>
            You will also see a list of all active events, leagues, and trips, and can go 
            directly to the manager site or portal for any of these leagues/events.
          </p>
          <p>
            From the Customer Center you can also create new events, leagues, and trips. Since 
            you have no leagues or events, this is your first step.
          </p>
          <p>
            Take advantage of our knowledge base by clicking on 
            <strong>
              Help 
            </strong>
            above or give us a call at 
            <strong>
              866-545-5098 
            </strong>
            (or +1 610 591 4891).
          </p>
          <p>
            Welcome to Golf Genius.
          </p>
          <div className='add-margin-top-20 add-margin-left-20'>
            <div className='signature'>
              <Image src={ require('home/genius/bios/zisman.jpg') }
                     circle={ true }
                     className="avatar" />
              <Image src={ require('home/mdz.png') }
                     className="sign" />
            </div>
            <div className='name'>
              Mike Zisman, CEO
            </div>
          </div>
        </Well>
      </Col>
    </Row>
  </Fragment>
)

export default WelcomeComponent
